/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { OperationType } from 'relay-runtime';
import { fg } from '@atlassian/jira-feature-gating';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import PrivatePageGroupAssignmentsQuery$parameters, {
	type PrivatePageGroupAssignmentsQuery,
} from '@atlassian/status-page/private-page-group-assignments-query/__generated__/PrivatePageGroupAssignmentsQuery.graphql';
import StatuspageDetailsPageQuery$parameters, {
	type StatuspageDetailsPageQuery,
} from './ui/__generated__/StatuspageDetailsPageQuery.graphql';

type CommunicationsStatusPageDetailsEntrypointComponent = EntryPointComponent<
	{
		StatuspageDetailsPageQuery: StatuspageDetailsPageQuery;
		PrivatePageGroupAssignmentsQuery?: PrivatePageGroupAssignmentsQuery;
	} & Record<string, OperationType>,
	{},
	{},
	{}
>;

export const communicationsStatusPageDetailsEntrypoint: EntryPoint<
	CommunicationsStatusPageDetailsEntrypointComponent,
	EntryPointRouteParams
> = createEntryPoint({
	root: JSResourceForUserVisible<CommunicationsStatusPageDetailsEntrypointComponent>(
		/* webpackChunkName: "async-communications-status-page-details-entrypoint" */ './ui/StatuspageDetailsPage.tsx',
		{
			entryFsSsrLiftImportToModule: true,
		},
	),
	getPreloadProps: ({ context, tenantContext }: EntryPointRouteParams) => {
		const pageId = context.match.params.pageId || '';
		return {
			queries: {
				StatuspageDetailsPageQuery: {
					parameters: StatuspageDetailsPageQuery$parameters,
					variables: {
						pageId,
						cloudId: tenantContext.cloudId,
					},
					options: {
						fetchPolicy: 'store-and-network' as const,
					},
				},
				...(pageId && fg('communications_enable_private_status_page')
					? {
							PrivatePageGroupAssignmentsQuery: {
								parameters: PrivatePageGroupAssignmentsQuery$parameters,
								variables: {
									pageId,
									cloudId: tenantContext.cloudId,
								},
								options: {
									// Warm the Relay store so the overview's useLazyLoadQuery can
									// hit the in-memory cache instead of round-tripping the network.
									fetchPolicy: 'store-and-network' as const,
								},
							},
						}
					: {}),
			},
		};
	},
});
